
@if (detail(); as item) {
  <div class="page-header">
    <div>
      <h1>Fahrer bearbeiten</h1>
      <p>Stammdaten, Zugang und Dokumentenstatus aktualisieren.</p>
    </div>
  </div>

  <form class="form-layout" (submit)="save($event)">
    <section class="panel">
      <h2>Stammdaten</h2>

      <div class="dialog-form">
        <label>
          <span>Vorname</span>
          <input type="text" required [value]="form().firstName" (input)="updateForm('firstName', $event)">
        </label>

        <label>
          <span>Nachname</span>
          <input type="text" required [value]="form().lastName" (input)="updateForm('lastName', $event)">
        </label>

        <label>
          <span>E-Mail</span>
          <input type="email" required [value]="form().email" (input)="updateForm('email', $event)">
        </label>

        <label>
          <span>Telefon</span>
          <input type="tel" [value]="form().phone" (input)="updateForm('phone', $event)">
        </label>

        <label>
          <span>Fahrernummer</span>
          <input type="text" [value]="form().personnelNumber" (input)="updateForm('personnelNumber', $event)">
        </label>

        <label>
          <span>Sprache</span>
          <select [value]="form().preferredLanguage" (change)="updateForm('preferredLanguage', $event)">
            <option value="de">Deutsch</option>
            <option value="en">Englisch</option>
            <option value="tr">Türkisch</option>
            <option value="ar">Arabisch</option>
            <option value="uk">Ukrainisch</option>
            <option value="ru">Russisch</option>
          </select>
        </label>
      </div>

      <h2 class="form-section-title">Organisation</h2>

      <div class="dialog-form">
        <label>
          <span>Betrieb</span>
          <select required [value]="form().companyId" (change)="updateCompany($event)">
            @for (company of companies(); track company.id) {
              <option [value]="company.id">{{ company.name }}</option>
            }
          </select>
        </label>

        <label>
          <span>Fahrergruppen</span>
          <select multiple size="2" (change)="updateGroups($event)">
            @for (group of driverGroupOptions(); track group.id) {
              <option [value]="group.id" [selected]="form().groupIds.includes(group.id)">{{ group.name }}</option>
            }
          </select>
          <small>Wähle eine oder mehrere Fahrergruppen aus, zum Beispiel Neue Fahrer, Nachschulung oder Krankenfahrt.</small>
        </label>
      </div>

      <h2 class="form-section-title">Dokumente</h2>

      <div class="dialog-form">
        <label>
          <span>Geburtsdatum</span>
          <input type="date" [value]="form().dateOfBirth" (input)="updateForm('dateOfBirth', $event)">
        </label>

        <label>
          <span>Führerschein gültig bis</span>
          <input type="date" [value]="form().licenseValidUntil" (input)="updateForm('licenseValidUntil', $event)">
        </label>

        <label>
          <span>P-Schein gültig bis</span>
          <input type="date" [value]="form().pScheinValidUntil" (input)="updateForm('pScheinValidUntil', $event)">
        </label>

      </div>

      @if (saveError()) {
        <p class="field-error">{{ saveError() }}</p>
      }
    </section>

    <aside class="edit-side-stack">
      <section class="panel">
        <h2>Zugang</h2>
        <label class="checkbox-row">
          <input type="checkbox" [checked]="form().accessActive" (change)="updateAccess($event)">
          <span>Benutzer aktiv</span>
        </label>
        <p class="muted-copy">Wenn der Benutzer deaktiviert ist, kann sich der Fahrer nicht im Portal anmelden.</p>
      </section>

      <section class="hint-panel">
        <h3>Hinweis</h3>
        <p>Beim Anlegen oder Bearbeiten wird kein Passwort vergeben. Sende in der Fahrerakte den Passwort-Link an den Fahrer.</p>
      </section>

      <section class="panel mini-button-stack">
        <button type="submit" class="primary-button" [disabled]="saving()">
          {{ saving() ? 'Wird gespeichert...' : 'Änderungen speichern' }}
        </button>
        <a class="ghost-button as-link" [routerLink]="['/drivers', item.driver.id]">Abbrechen</a>
      </section>
    </aside>
  </form>
} @else {
  <div class="empty">Fahrer wird geladen.</div>
}
  
